import type { ReactNode } from 'react';
import { cn } from '@shared/lib/utils';

/** Ряд действий в модалке: сначала secondary (отмена), затем default (подтверждение). */
export const buttonActionsClassName =
  'flex flex-col-reverse gap-2 sm:flex-row sm:flex-wrap sm:justify-end sm:gap-2 [&_button]:w-full sm:[&_button]:w-auto';

interface ButtonGroupProps {
  children: ReactNode;
  className?: string;
}

/** Горизонтальная группа кнопок по DS: secondary + default. */
export function ButtonGroup({ children, className }: ButtonGroupProps) {
  return <div className={cn(buttonActionsClassName, className)}>{children}</div>;
}
